<template>
  <div v-if="!isLoading" class="recently-active">
    <div class="recently-active__title-wrapper">
      <h6 class="recently-active__title">
        Other courses in {{ learningPath.name }}
      </h6>
    </div>
    <Swiper
      class="recently-active__swiper"
      :parentClass="`recently-active__active-courses`"
      :swiperOptions="swiperOptions"
      :disabled="courses.length <= 4"
      @slide-changed="handleSlideChange"
      @first-slide="handleSlideChange"
    >
      <div
        v-for="(course, i) in courses"
        :key="course.uuid"
        :class="[
          'swiper-slide',
          'recently-active__tile-wrapper',
          i === 0 &&
            isFirstSlideActive &&
            'recently-active__tile-wrapper--first',
        ]"
      >
        <CourseTile
          :height="386"
          :course="{
            ...course,
            id: course.uuid,
            learning_areas: [{ name: getLearningArea() }],
          }"
          :isFreeTrialUser="false"
        />
      </div>
    </Swiper>
  </div>
  <div v-else class="recently-active recently-active__loader">
    <ActionLoader />
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import { mapState } from 'vuex'
import Swiper from '@/components/layout/Swiper.vue'
import CourseTile from '@/components/layout/CourseTile.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import { getLearningAreaName } from '@/helpers'

export default {
  name: 'RecentlyActive',
  components: {
    Swiper,
    CourseTile,
    ActionLoader,
  },
  data() {
    return {
      isLoading: true,
      isFirstSlideActive: true,
      swiperOptions: {
        loop: false,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
          500: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: 2.75,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 3.25,
            spaceBetween: 15,
          },
          1300: {
            slidesPerView: 4.25,
            spaceBetween: 15,
          },
        },
      },
    }
  },
  computed: {
    ...mapState({
      learningPath: state => state.content.recentLearningPath,
    }),
    courses() {
      return this.learningPath.content
        .map(group => group.content.filter(c => c.content_type === 'course'))
        .flat(1)
    },
  },
  methods: {
    getLearningArea() {
      if (this?.learningPath) {
        return getLearningAreaName(this.learningPath)
      }
      return 'INE'
    },
    handleSlideChange(evt) {
      const index = evt?.activeIndex ?? 0
      this.isFirstSlideActive = index === 0
    },
  },
  async mounted() {
    this.isLoading = true
    await this.$store.dispatch(
      'content/getRecentLearningPath',
      CONSTANTS.HOME_PAGE.FALLBACK_CONTENT.LEARNING_PATH.id
    )
    this.isLoading = false
  },
}
</script>

<style lang="scss">
.recently-active {
  &__loader {
    margin: 25px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 386px;
    @include tablet {
      margin: 25px 0 45px 115px;
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
    }
  }
}
</style>
